import script from "./CurrencyPairHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyPairHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyPairHeader.vue?vue&type=style&index=0&id=0203a994&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0203a994"]])

export default __exports__